import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import { SpeakerEntry, StageComponentInterface } from '../../../../../interfaces/pagebuilder';
import MbwSpeakerButton from './MBWSpeakerButton';
import MbwSpeakerItem from './MBWSpeakerItem';

const MbwStageSpeakers = ({ uiComponent }: { uiComponent: StageComponentInterface }) => {
  const [selectedSpeaker, setSelectedSpeaker] = useState<SpeakerEntry>();
  const { t } = useTranslation();

  const imagesCount = uiComponent.entryIds?.filter((speaker) => speaker.image).length ?? 0;
  return (
    <div className="flex flex-col w-full">
      <div className="flex justify-between pt-4 pl-4 pr-4 mb-4">
        <span className="text-xl font-bold">{uiComponent.speakersTitle}</span>
        {selectedSpeaker && (
          <MbwSpeakerButton onClick={() => setSelectedSpeaker(undefined)}>
            <span className="p-1 pl-6 pr-6 font-bold">{t('account:overview')}</span>
          </MbwSpeakerButton>
        )}
      </div>
      {!selectedSpeaker &&
        uiComponent.entryIds?.map((speaker) => (
          <MbwSpeakerItem
            showImageHolder={imagesCount > 0}
            speaker={speaker}
            onSelect={(speaker) => setSelectedSpeaker(speaker)}
            iconColor={uiComponent?.styling?.textColor}
          />
        ))}
      {selectedSpeaker && (
        <MbwSpeakerItem showImageHolder={!!selectedSpeaker.image} speaker={selectedSpeaker} showDetails iconColor={uiComponent?.styling?.textColor} />
      )}
    </div>
  );
};

export default MbwStageSpeakers;
